export default {
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : '/api',
  ElementSize: 'small',
  Title: 'rjelement',
  LANG: 'en'
};
